import ResetPasswordForm from '../components/Auth/ResetPassword';

const ResetPasswordPage = () => <ResetPasswordForm />;

export default ResetPasswordPage;